<template>
  <span id="screenshot" class="screenshot" v-show="show">
    <el-dropdown trigger="click">
      <el-button class="screenshot-btn el-dropdown-link" type="danger" icon="el-icon-s-comment" circle></el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item icon="el-icon-edit" @click.native="handleOk">吐槽</el-dropdown-item>
        <el-dropdown-item icon="el-icon-user" @click.native="handleMe">我的</el-dropdown-item>
        <el-dropdown-item icon="el-icon-close" @click.native="show=false">关闭</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dialog modal-append-to-body append-to-body :title="'吐槽'" top="50px" :visible.sync="box" width="60%">

      <el-input type="textarea" placeholder="请告诉我们遇到的问题或建议" v-model="form.text"></el-input>
      <div v-if="startScreenshot" v-loading="flag" element-loading-text="正在截取屏幕数据" class="screenshot__img">
        <img :src="form.img" width="100%" />
      </div>
      <div slot="footer" class="screenshot__menu">

        <el-button type="warning" icon="el-icon-full-screen" @click="openScreenshot">截屏</el-button>
        <el-button type="success" icon="el-icon-check" @click="handleSubmit">提交</el-button>
      </div>
    </el-dialog>
    <div v-show="showDrawer">
      <devops ref="devops" />
    </div>
  </span>

</template>
<script>
import html2canvas from 'html2canvas'
import axios from 'axios'
import devops from './feedBackDrawer'
export default {
  name: 'screenshot',
  components: {
    devops
  },
  data() {
    return {
      //反馈信息是否展示
      showDrawer: false,
      startScreenshot: false,
      show: true,
      open: false,
      box: false,
      form: {
        img: '',
        text: '',
      },
    }
  },
  computed: {
    flag() {
      return !this.form.img
    },
  },
  methods: {
    handleSubmit() {
      this.box = false
      axios
        .post(process.env.VUE_APP_OA_HOST_URL + 'devops/feedBack', {
          info: this.form.text,
          image: this.form.img,
        })
        .then((res) => {
          this.$message.success('反馈提交成功')
        })
    },
    openScreenshot() {
      this.startScreenshot = true
      setTimeout((res) => {
        this.form['img'] = ''
        html2canvas(document.querySelector('#app'), {
          ignoreElements: (element) => {
            if (element.id == 'screenshot') {
              return false
            }
          },
        }).then((canvas) => {
          this.form.img = canvas.toDataURL('image/jpeg', 0.8)
        })
      }, 100)
    },
    handleOk() {
      this.box = true
      this.form.img = null
      this.form.text = ''
      this.startScreenshot = false
    },
    //我的反馈
    handleMe() {
      //打开反馈页面
      this.showDrawer = true
      this.$refs.devops.getBackInfo()
    },
    openVersion() {
      this.open = true
    },
  },
}
</script>
<style scoped>
.screenshot {
  position: fixed;
  bottom: 86px;
  right: 26px;
  z-index: 2048;
}

.screenshot .screenshot-btn {
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  width: 40px;
  height: 40px;
  font-size: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.screenshot__img {
  min-height: 200px;
  margin-top: 20px;
  padding: 10px 20px;
  box-sizing: border-box;
  border: 1px solid #eee;
  width: 100%;
}

.screenshot__menu {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/screenshot.vue